


// import React, { useState } from 'react';
// import logoutGif from '../assets/logout.gif'; // Adjust the path based on the location of your GIF file

// export default function Logout() {
//   const [open, setOpen] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleLogout = () => {
//     // Handle logout functionality here
//     console.log("User logged out");
//     handleClose();
//   };

//   return (
//     <>
//       <button
//         onClick={handleOpen}
//         className="bg-orange-600 text-white py-2 px-4 rounded"
//       >
//         Logout
//       </button>

//       {open && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//           <div className="bg-white rounded-lg shadow-lg max-w-sm w-full text-center">
            
//             {/* Title Section - Separated from the content */}
//             <div className="bg-orange-600 py-2 rounded-t-lg">
//               <h2 className="text-white text-lg font-semibold">Logout</h2>
//             </div>

//             {/* GIF Section */}
//             <img src={logoutGif} alt="Logout Animation" className="w-16 h-24 mx-auto my-2 " />

//             {/* Confirmation Text */}
//             <p className="text-gray-700 text-base mb-6">Are you sure you want to logout?</p>

//             {/* Action Buttons */}
//             <div className="flex justify-between space-x-4 p-3">
//               <button
//                 onClick={handleClose}
//                 className="bg-gray-300 text-gray-700 py-2 px-4 rounded font-semibold w-1/2"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleLogout}
//                 className="bg-red-600 text-white py-2 px-4 rounded font-semibold w-1/2"
//               >
//                 yes, Logout!
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


// import React from 'react';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// import logoutGif from '../assets/logout.gif'; // Adjust the path based on the location of your GIF file

// const Logout = () => {
//   const navigate = useNavigate(); // Initialize navigation hook

//   // Define handleClose function to close the modal
//   const handleClose = () => {
//     // Logic to close the modal (e.g., setting a state or triggering parent action)
//     console.log('Modal closed');
//   };

//   // Define handleLogout function to handle logout logic
//   const handleLogout = () => {
//     // Handle logout functionality here (e.g., clearing user session, redirecting)
//     console.log('User logged out');
//     handleClose();
//     navigate('/'); // Redirect to login page after logout
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white rounded-lg shadow-lg max-w-sm h-auto w-full text-center">

//         {/* Title Section - Separated from the content */}
//         <div className="bg-orange-600 py-2 rounded-t-lg">
//           <h2 className="text-white text-lg font-semibold">Logout</h2>
//         </div>

//         {/* GIF Section */}
//         <img src={logoutGif} alt="Logout Animation" className="w-16 h-24 mx-auto my-2" />

//         {/* Confirmation Text */}
//         <p className="text-gray-700 text-base mb-6">Are you sure you want to logout?</p>

//         {/* Action Buttons */}
//         <div className="flex justify-between space-x-4 p-3">
//           <button
//             onClick={handleClose}
//             className="bg-gray-300 text-gray-700 py-2 px-4 rounded font-semibold w-1/2"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleLogout}
//             className="bg-red-600 text-white py-2 px-4 rounded font-semibold w-1/2"
//           >
//             Yes, Logout!
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Logout;

import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; // Import useDispatch
import logoutGif from "../assets/logout.gif"; // Adjust the path based on the location of your GIF file
import { logout } from "../../Redux/Slice/LoginSlice"; // Import logout action

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleLogout = () => {
    dispatch(logout()); // Dispatch logout action
    navigate("/"); // Redirect to the home or login page after logout
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-sm h-auto w-full text-center">

        {/* Title Section */}
        <div className="bg-orange-600 py-2 rounded-t-lg">
          <h2 className="text-white text-lg font-semibold">Logout</h2>
        </div>

        {/* GIF Section */}
        <img src={logoutGif} alt="Logout Animation" className="w-16 h-24 mx-auto my-2" />

        {/* Confirmation Text */}
        <p className="text-gray-700 text-base mb-6">Are you sure you want to logout?</p>

        {/* Action Buttons */}
        <div className="flex justify-between space-x-4 p-3">
          <button
            onClick={handleClose}
            className="bg-gray-300 text-gray-700 py-2 px-4 rounded font-semibold w-1/2"
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            className="bg-red-600 text-white py-2 px-4 rounded font-semibold w-1/2"
          >
            Yes, Logout!
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
